import { render, staticRenderFns } from "./OrderFormPoint.vue?vue&type=template&id=8e749c98&scoped=true&"
import script from "./OrderFormPoint.vue?vue&type=script&lang=js&"
export * from "./OrderFormPoint.vue?vue&type=script&lang=js&"
import style0 from "./OrderFormPoint.vue?vue&type=style&index=0&id=8e749c98&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e749c98",
  null
  
)

export default component.exports